import { apiGetAuth, apiPostAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_USER_MANAGEMENT, API_CAMPAIGN, API_DIGITAL_STAMP } from '@/utils/api-url'
import router from '@/router'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    rewards: { data: [] },
    detail_reward: {},
    data_promo: {},
    detail_user: { data: []},
    campaigns: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_REWARDS (state, payload) {
    state.rewards = payload
  },
  SET_DETAIL_REWARD (state, payload) {
    state.detail_reward = payload
  },
  SET_DATA_PROMO (state, payload) {
    state.data_promo = payload
  },
  SET_DETAIL_USER (state, payload) {
    state.detail_user = payload
  },
  SET_CAMPAIGNS (state, payload) {
    state.campaigns = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListPromo(context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.GET_PROMO_CODE_REWARD, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListReward(context, payload) {
    try {
      const response = await apiGetAuth(API_DIGITAL_STAMP.REWARD, payload)
      context.commit('SET_REWARDS', response.data.data)
      context.commit('SET_META_FILTER', payload)
      router.push({name: 'Rewards', query: payload})
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getDetailReward(context, payload) {
    try {
      const response = await apiGetAuth(API_DIGITAL_STAMP.REWARD_DETAIL(payload))
      context.commit('SET_DETAIL_REWARD', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListCampaign (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_CAMPAIGN, payload)
      context.commit('SET_CAMPAIGNS', response.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListAllDetailUser (context, payload) {
    try {
      const response = await apiPostAuth(API_USER_MANAGEMENT.ALL_USERNAME, payload)
      context.commit('SET_DETAIL_USER', response.data.data)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async createReward (context, payload) {
    try {
      const response = await apiPostAuth(API_DIGITAL_STAMP.REWARD, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateReward (context, {id, reqBody}) {
    try {
      const response = await apiPutAuth(API_DIGITAL_STAMP.REWARD_UPDATE_DELETE(id), reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteReward(context, payload) {
    try {
      const response = await apiDeleteAuth(API_DIGITAL_STAMP.REWARD_UPDATE_DELETE(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  list_rewards (state) {
    return state.rewards
  },
  list_detail_reward (state) {
    return state.detail_reward
  },
  list_data_promo (state) {
    return state.data_promo
  },
  list_detail_user (state) {
    return state.detail_user
  },
  list_campaigns (state) {
    return state.campaigns
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
